<template name = "dateTemplate" lang="html">
	
	<div class="row">
        <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>

	  <div id="sidebarMenu" class="sidebar-fixed bg-white sidebar">
		 <div class="sidebar-header">
			<h5>Search</h5>
			<a href="" id="sidebarMenuClose"><feather type="x" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather></a>
		 </div><!-- df-sidebar-header -->
		 <vueCustomScrollbar>
			<div class="sidebar-body">
                <ul class="sidebar-nav">
                    <div id="app">
                        <v-app id="inspire">
                            <div>
                                <v-date-picker v-model="picker" @click:month="classifyData()" width="200" type="month"></v-date-picker>
                            </div>
                        </v-app>
                    </div>
                </ul>
				<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms">
					<li class="nav-label mg-b-10-f" v-if="i === 0">Input Search</li>
					<div class="form-group">
						<label for="formGroupExampleInput" class="d-block">{{form.name}}</label>
						<input type="text" @keyup.enter="textKeyupEvent" class="form-control" v-model="form.value" :id="form.id" :placeholder="form.name">
					</div>
				</ul>
                <ul class="sidebar-nav" v-for="(form, i) in inputDeptForms">
					<div class="form-group">
						<label for="formGroupExampleInput" class="d-block">{{form.name}}</label>
                        <b-field>
                            <b-autocomplete
                                v-model="deptName"
                                :id="form.id"
                                ref="deptName"
                                :data="filteredDeptArray"
                                :placeholder="form.name"
                                @keyup.native.enter="classifyData()"
                                @select="option => selected = option">
                            </b-autocomplete>
                        </b-field>
						
					</div>
				</ul>
				<ul class="sidebar-nav" v-for="(form, i) in inputCompanyForms">
					<div class="form-group">
						<label for="formGroupExampleInput" class="d-block">{{form.name}}</label>
                        <b-field>
                            <b-autocomplete
                                v-model="companyName"
                                :id="form.id"
                                ref="companyName"
                                :data="filteredCompArray"
                                :placeholder="form.name"
                                @keyup.native.enter="classifyData()"
                                @select="option => selected = option">
                            </b-autocomplete>
                        </b-field>
						<!-- <input type="text" @keyup.enter="textKeyupEvent" class="form-control" v-model="form.value" :id="form.id" :placeholder="form.name"> -->
					</div>
				</ul>
				<ul class="sidebar-nav mg-t-35-f" v-for="(form, i) in dateRangeSearchForms">
					<li class="nav-label mg-b-10-f" v-if="i === 0">Date Range Search</li>
					<label for="formGroupExampleInput" class="d-block">{{form.name}}</label>
					<li class="nav-item"><date-picker @dp-change="dateKeyupEvent" v-model="form.fvalue" :config="datePickerOptions" class="form-control" autocomplete='off' placeholder="From date" :id="form.fid" aria-label="Search" ignoreReadonly/></li>
					<li class="nav-item"><date-picker @dp-change="dateKeyupEvent" v-model="form.evalue" :config="datePickerOptions" class="form-control" autocomplete='off' placeholder="To date" :id="form.eid" aria-label="Search" ignoreReadonly/></li>
				</ul>
				<!-- <ul class="sidebar-nav mg-t-35-f" v-for="(form, i) in dateSearchForms">
					<li class="nav-label mg-b-10-f" v-if="i === 0">Date Search</li>
					<label for="formGroupExampleInput" class="d-block">{{form.name}}</label>
					<li class="nav-item"><date-picker @dp-change="dateKeyupEvent" v-model="form.fvalue" :config="datePickerOptions" class="form-control" autocomplete='off' placeholder="From date" :id="form.fid" aria-label="Search" ignoreReadonly/></li>
					<li class="nav-item"><date-picker @dp-change="dateKeyupEvent" v-model="form.evalue" :config="datePickerOptions" class="form-control" autocomplete='off' placeholder="To date" :id="form.eid" aria-label="Search" ignoreReadonly/></li>
				</ul> -->
				<ul class="sidebar-nav mg-t-35-f" v-for="(form, i) in checkboxSearchForms">
					<li class="nav-label mg-b-10-f" v-if="i === 0">Checkbox Search</li>
					<label for="formGroupExampleInput" class=" d-block">{{form.name}}</label>   
					<div class="custom-control custom-checkbox mg-b-7" :id="form.id" v-for="(form1, i) in form.subs">
						<input type="checkbox" v-on:click="checkClickEvent" class="custom-control-input" :id="form1.codeCode" :value="form1.codeCode">
						<label class="custom-control-label" :for="form1.codeCode">{{form1.codeName}}</label>
					</div> 
				</ul>
			</div><!-- sidebar-body -->
		</vueCustomScrollbar>
      </div><!-- sidebar -->
      <div class="content content-components overflow-hidden">
         <div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
            <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
               <div>
                  <nav aria-label="breadcrumb">
                     <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                        <li class="breadcrumb-item">{{this.mainName}}</li>
                        <li class="breadcrumb-item active" aria-current="page">{{this.subName}} List</li>
                     </ol>
                     <h4 class="mg-b-0 tx-spacing--1">{{this.subName}} List</h4>
                  </nav>
                </div>
                <div class="card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end">
                    <router-link v-if="this.$route.name != 'orderconfirms' && this.$route.name != 'results' " class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" :to="{name:this.$route.name+'_detail', params:{mid:this.properties.mid, type:'detail'}}"><feather type="file" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Create</router-link>
                </div>
            </div>
            <div class="row row-xs">
				<div class="fixedHeader col-lg-12 mg-t-10 b-table" v-bind:class="[b_scroll ? 'display-inline-block' : 'display-none']"></div>
                <div class="col-lg-12 mg-t-10">
                    <section>
                        <b-field grouped group-multiline>
                           <b-select v-model="perPage" :disabled="!isPaginated">
                              <option value="20">20</option>
                               <option value="50">50</option>
                               <option value="100">100</option>
                               <option value="200">200</option>
                            </b-select>
                        </b-field>
                    </section>
                    <section>
                        <b-table
                            :data="isEmpty ? [] : data"
                            :loading="loading"
                            paginated
                            hoverable
                            striped
                            backend-pagination
                            class="overflow-x-hidden"
                            :total="total"
                            :per-page="perPage"
                            @page-change="onPageChange"
                            aria-next-label="Next page"
                            aria-previous-label="Previous page"
                            aria-page-label="Page"
                            aria-current-label="Current page"
                            backend-sorting
                            :default-sort="[sortField, sortOrder]"
                            @sort="onSort"
                            id="listTable"
                            
                        >
                        <template slot-scope="props">
                            <b-table-column 
                                field="no"
                                label="No">
                                {{ props.row.no }}
                            </b-table-column>
                            <b-table-column v-for="(form, i) in headers"
                              v-if="i == 0"
                              :key="i"
                              :field="form.columnCode"
                              :label="form.columnName"
                              centered sortable
                              ><a href='#' @click='goPage(props.row.id, props.row.stateCode, props.row.creatorId)'>
                                  
                                 {{ props.row[form.columnCode] }}
                              </a>
                           </b-table-column>
                           <b-table-column v-for="(form, i) in headers"
                              v-if="i > 0"
                              :key="i"
                              :field="form.columnCode"
                              :label="form.columnName"
                              centered sortable >
                              {{ props.row[form.columnCode]}}
                           </b-table-column>
                           <b-table-column 
                                v-if="mainName == 'Result'"
                                field="read"
                                label="Read"
								centered>
						    <a href="#" @click='dialog3Handler(props.row)' :id="props.index" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="more-horizontal" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather></a>
                           </b-table-column>
                           <b-table-column 
                                v-if="mainName == 'Result'"
                                field="qwrap"
                                label="QWRAP Report"
								centered>
						    <a href="#" @click='loadHtml(props.row.id)' :id="props.index" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="book-open" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather></a>
                           </b-table-column>
                           <b-table-column 
                                v-if="mainName == 'Result'"
                                field="research"
                                label="Research Report"
								centered>
						    <a href="#" @click="dialogHandler(props.row.id)" :id="props.index" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="download" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather></a>
                      
                           </b-table-column>
                           <b-table-column 
                                v-if="mainName == 'Result'"
                                field="sampleInfo"
                                label="Sample Info"
								centered>
						    <a href="#" @click="setLinkdialogHandler(props.row)" :id="props.index" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="hard-drive" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather></a>
                      
                           </b-table-column>
                        </template>
                        <template slot="empty">
                        <section class="section">
                          <div class="content has-text-grey has-text-centered">
                            <p>Nothing here.</p>
                          </div>
                        </section>
                      </template>
                     </b-table>
                  </section>
               </div><!-- col -->
            </div><!-- row -->
        </div><!-- container -->
    </div><!-- content -->
        <v-app id="inspire">
            <div>
                <v-row
                    justify="center"
                >
                    <v-dialog
                    v-model="researchReportDialog"
                    max-width="500px"
                    style='z-index:20001;'
                    >
                        <v-card>
                            <v-card-title>
                            Research Report
                            </v-card-title>
                            <v-card-text>
                            <v-select
                                v-model="reportType"
                                :items="select[this.properties.task]"
                                label="A Select Report Type"
                                item-value="text"
                            ></v-select>
                            </v-card-text>
                            <v-card-actions>
                            <v-btn
                                color="primary"
                                text
                                @click="researchReportDialog = false"
                            >
                                Close
                            </v-btn>
                            <v-btn
                                color="primary"
                                text
                                type="button"
                                :loading="btnLoading" 
                                @click="loadReport()"
                            >
                                Load
                            </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
            </div>
        </v-app>

         <v-app id="inspire">
            <div>
                <v-row
                    justify="center"
                >
                    <v-dialog
                    v-model="dialog3"
                    max-width="570px"
                    scrollable
                    style='z-index:20001;'
                    >
                        <v-card>
                            <v-toolbar
                                class="mb-2"
                                color="indigo darken-5"
                                dark
                                flat
                            >
                                <v-toolbar-title>Read Count</v-toolbar-title>
                                <v-divider></v-divider>
                                <v-card-title>
                                    <h4>{{ readTask }}</h4>
                                </v-card-title>
                            </v-toolbar>
                            <v-card-text style="max-height: 300px;">
                                <v-list dense>
                                    <v-list-item  v-for="(item) in readList" :key="item.key">
                                        <v-list-item-content>{{item.key}}:</v-list-item-content>
                                        <v-list-item-content class="align-end">
                                            {{ item.value }}
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
								<!--<li v-for="(item, index) in readList">{{item}}</li> -->
                            <!-- <v-select
                                v-model="reportType"
                                :items="select[this.properties.task]"
                                label="A Select Report Type"
                                item-value="text"
                            ></v-select> -->
							<!-- {{this.subName}} Report -->
                            </v-card-text>
                            <v-card-actions>
                            <v-btn
                                color="primary"
                                text
                                @click="dialog3 = false"
                            >
                                Close
                            </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
            </div>
        </v-app>
         <v-app id="inspire">
            <div>
                <v-row
                    justify="center"
                >
                    <v-dialog
                    v-model="linkDialog"
                    max-width="570px"
                    scrollable
                    style='z-index:20001;'
                    >
                        <v-card>
                            <v-toolbar
                                class="mb-2"
                                color="indigo darken-5"
                                dark
                                flat
                            >
                                <v-toolbar-title><feather type="link" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Sample Info </v-toolbar-title>
                                <v-divider></v-divider>
                               <!-- <v-card-title>
                                    <h4>ddd</h4>
                                </v-card-title>-->
                            </v-toolbar>
                            <v-card-text style="max-height: 500px;">
                            <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Company / Institution</v-list-item-title>
                                <v-text-field
                                ref="company"
                                v-model="company"
                                label="Company / Institution"
                                />
                            </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Date Of Sample Reception</v-list-item-title>
                                <v-text-field
                                ref="receptionDate"
                                v-model="receptionDate"
                                label="Date Of Sample Reception"
                                />
                            </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Report Type</v-list-item-title>
                                <v-text-field
                                ref="rType"
                                v-model="rType"
                                label="Report Type"
                                />
                            </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Target Region</v-list-item-title>
                                <v-text-field
                                ref="targetRegion"
                                v-model="targetRegion"
                                label="Target Region"
                                />
                            </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Requested Read Count</v-list-item-title>
                                <v-text-field
                                ref="requestedRead"
                                v-model="requestedRead"
                                label="Requested Read Count"
                                />
                            </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Rarefied Read Count</v-list-item-title>
                                <v-text-field
                                ref="rarefiedRead"
                                v-model="rarefiedRead"
                                label="Rarefied Read Count"
                                />
                            </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Type of Sequencer</v-list-item-title>
                                <v-text-field
                                ref="sequencer"
                                v-model="sequencer"
                                label="Sequencer"
                                />
                            </v-list-item-content>
                            </v-list-item>    
                            <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Drive Link</v-list-item-title>
                                <v-text-field
                                    label="LINK"
                                    v-model="driveLink"
                                />
                            </v-list-item-content>
                            </v-list-item>    
                                
                         
                            </v-card-text>
                            <v-card-actions>
                            <v-btn
                                color="primary"
                                text
                                @click="linkDialog = false"
                            >
                                Close
                            </v-btn>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="linkDialog = false, setLink()"
                            >
                                Save
                            </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
            </div>
            <v-snackbar
        v-model="snackBar"
      >
        {{ snackBarMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="snackBar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <div class="text-center">
        <v-overlay :value="overlay">
          <div style="display:flex;justify-content:center;flex-direction:column">
            <div style="margin-bottom:10px;">
              <v-progress-circular
                indeterminate
                size="64"
              />
            </div>
            <b>{{downloadMsg}}</b>
            <div>
            </div>
            <div>
              <b> {{ downloadProgress }} % </b>
            </div>
          </div>
        </v-overlay>
      </div>
        </v-app>
   </div>
</template>
<script>
	/* 데이터 테이블 헤더 고정 외부 라이브러리 import */
	//import {floatThead} from '@/lib/floatThead/jquery.floatThead.min.js';
	/* 날짜 입력을 위한 외부 라이브러리 import */
	import datePicker from "vue-bootstrap-datetimepicker";
	import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
    
	import moment from "moment";
	import vueCustomScrollbar from 'vue-custom-scrollbar'
	// 공통 스크립트
	import common from "@/views/Common/common.js";
	// Header의 메뉴 정보 호출을 위한 bus event
    import { bus } from "../../main";
    
    import Chat from "@/views/Common/Chat";
    import { logoAndroid } from '../../lib/ionicons/dist/collection/icon/svg/index.esm';
    import saveAs from 'file-saver/src/FileSaver';

	$(function() {
	// $('#dataTable').floatThead({
	//	top: 60,
	//	position: 'auto'
	// }); // 테이블 헤더 고정
	});

	export default {
	name: "List",
	props: ["properties"],
	data() {
		return {
            btnLoading: false,
            overlay: false,
            downloadMsg: '',
            downloadProgress: '',
            //Analysis Params
            company: '',
            receptionDate: '',
            targetRegion: '',
            rType: '16S',
            requestedRead: '20000',
            rarefiedRead: '20000',
            sequencer: 'Illumina MiSeq',

            snackBar: false,
            snackBarMessage: '',
            picker: new Date().toISOString().substr(0, 7),
            landscape: false,
            researchReportDialog: false,
            dialog3: false,
            linkDialog: false,
            driveLink: '',
            selectedRow: {},
            readList: [],
            readTask: '',
            reportType:'',
            select: {
                "GutMorning": 
                    [
                        { text: '16S Microbiome Report' },
                        { text: 'EDGC 16S Microbiome Report' },
                        { text: 'GutMorningXlsx' },
                        { text: 'JSON' },
                        { text: 'ITS Microbiome Report' },

                    ]
                ,
                "GutMorning-Silva":
                    [
                        { text: '16S Microbiome Report' },
                        { text: 'EDGC 16S Microbiome Report' },
                        { text: '18S Microbiome Report' },
                        { text: 'Qiime2 Microbiome Report' },
                    ]
                ,   
                "GutMorning-Fungal":
                    [
                        { text: 'ITS Microbiome Report' },
                        { text: 'EDGC 16S Microbiome Report' },
                        { text: 'ITS2 Microbiome Report' },
                        { text: 'Qiime2 Microbiome Report' },
                    ]
                , 
                "The Clinic": 
                    [
                        { text: '16S Microbiome Report' },
                        { text: 'EDGC 16S Microbiome Report' },
                        { text: 'GutMorningXlsx' },
                        { text: 'JSON' },
                        { text: 'ITS Microbiome Report' },
                    ]
                ,
                "MossGenomics": 
                    [
                        { text: '16S Microbiome Report' },
                        { text: 'EDGC 16S Microbiome Report' },
                        { text: 'GutMorningXlsx' },
                        { text: 'JSON' },
                        { text: 'ITS Microbiome Report' },
                    ]
                ,
            } 
            ,

			// date setting
			datePickerOptions: {
				format: "YYYY-MM-DD",
				useCurrent: false,
				showTodayButton: true,
				keepInvalid: false,
				ignoreReadonly: true
			},

            /* Loading */
            isLoading: false,
            isFullPage: true,

			menuData: [],
			mid: "",

			// menu name
			mainName: "",
			subName: "",

			// list data
			headers: [],
			data: [],
			isEmpty: false,
			isPaginated: true,
			total: 0,
			loading: false,
			sortField: "",
			sortOrder: "",
			page: 1,
			perPage: 200,

			// Search data
			inputSearchForms: [],
			dateRangeSearchForms: [],
			dateSearchForms: [],
			checkboxSearchForms: [],
            inputCompanyForms: [],
            inputDeptForms: [],

            //auto complete
            deptName : "",
            companyName : "",
            autoCompanyData: [],
            autoDeptData: [],

            userid: '',
            
            official: '',

			draftsFlag: false,

			b_clone: false,
			b_scroll: false,
			
            clientManager : "b792082f-8fd4-4411-bf40-5dab947cd697"
		};
	},
	beforeDestroy() {
		bus.$off("menu_data");
		bus.$off("userinfo");
		window.removeEventListener("scroll", this.onScroll);
	},
	created() {
        this.getAutoCompleteData()
    },
	mounted() {
		bus.$on("menu_data", data => {
			this.menuData = data;
            this.classifyHeader();
		});
		bus.$on("userinfo", data => {
            this.official = data.official;
			this.userid = data.id;
		});
		window.addEventListener("scroll", this.onScroll);
	},
	methods: {
		/*
		* keyup search
		*/
		textKeyupEvent() {
			this.classifyData();
		},
		dateKeyupEvent(e) {
			if (e.oldDate != null) this.classifyData();
		},
		checkClickEvent(e) {
			this.classifyData();
		},
        /*
        * Auto Data
        */
        async getAutoCompleteData() {
            await this.$axios.get(this.$apiHost + "/users/autolist").then(res => {
                let compN = [];
                let deptN = [];
                for(let i in res.data.companyArr){
                    compN.push(res.data.companyArr[i].companyName)
                }
                for(let i in res.data.deptArr){
                    deptN.push(res.data.deptArr[i].kor)
                }
                this.autoCompanyData = compN; //자동완성 데이터
                this.autoDeptData = deptN; //자동완성 데이터
            });
        },
		/*
		* Load Headers
		*/
		async classifyHeader() {
            let data = common.menuHeader(this.properties.mid, this.menuData, 1);
            this.mainName = data[0];
            this.subName = data[1];
            
            // if (this.properties.task) {
            //     this.subName = this.properties.task;
            // }
			this.headers = data[3];
			let exp_result = common.thisDetailResult(this.properties.mid, this.menuData);
            if(exp_result.length > 0){
                exp_result.forEach(a=>{
                this.headers.push({columnCode: a.codeCode, columnName: a.codeName, columnType: 'COUNT'})
				});
				this.headers.push({columnCode: 'R', columnName: 'Re-Exp', columnType: 'COUNT'})
				this.headers.push({columnCode: 'wait', columnName: 'Wait', columnType: 'COUNT'})
				this.headers.push({columnCode: 'electrophoresis', columnName: 'Electrophoresis', columnType: 'COUNT'})
				this.headers.push({columnCode: 'tapestation', columnName: 'TapeStation', columnType: 'COUNT'})
            }
            if (this.$route.name === 'orderconfirms') {
                let temp = [];
                for (let i in this.headers) {
                    temp = this.headers.filter(item => item.columnType !='COUNT')
                }
                this.headers = temp;
                this.headers.push({columnCode: 'total', columnName: 'Total', columnType: 'COUNT'});
                this.headers.push({columnCode: 'obtainOrder', columnName: 'ObtainOrder', columnType: 'COUNT'});
                this.headers.push({columnCode: 'reOrder', columnName: 'ReOrder', columnType: 'COUNT'});
                this.headers.push({columnCode: 'cancel', columnName: 'Cancel', columnType: 'COUNT'});
                this.headers.push({columnCode: 'discard', columnName: 'Discard', columnType: 'COUNT'});
			}
            this.createSearchForm();
            this.classifyData();
        },
		/*
		* search form create
		*/
		createSearchForm() {
			this.inputSearchForms = [];
			this.inputCompanyForms = [];
			this.dateSearchForms = [];
			this.checkboxSearchForms = [];
			for (let i in this.headers) {
				if (this.headers[i].columnType == "LIST") {
					if(this.headers[i].columnAttr == 'usedcode') this.checkboxSearchForms.push({name: this.headers[i].columnName,value: [],subs: [{codeCode: 1, codeName: 'Used'},{codeCode: 0,codeName: 'Unused'}],id: this.headers[i].columnCode});
					else this.checkboxSearchForms.push({name: this.headers[i].columnName,value: [],subs: this.headers[i].code,id: this.headers[i].columnCode});
				} else if (this.headers[i].columnType == "DATE") {
					this.dateSearchForms.push({name: this.headers[i].columnName,id: this.headers[i].columnCode,fvalue: "",evalue: "",fid: "f_" + this.headers[i].columnCode,eid: "e_" + this.headers[i].columnCode});
				} else if (this.headers[i].columnType == "DATERANGE") {
					this.dateRangeSearchForms.push({name: this.headers[i].columnName,id: this.headers[i].columnCode,fvalue: "",evalue: "",fid: "f_" + this.headers[i].columnCode,eid: "e_" + this.headers[i].columnCode});
				}else if (this.headers[i].columnType == "RANGE") {
				} else if (this.headers[i].columnType == "COUNT") {
				} else if (this.headers[i].columnType == "COMPANY") {
                    this.inputCompanyForms.push({name: this.headers[i].columnName,value: "",id: this.headers[i].columnCode,division: this.headers[i].columnDivision, 'attr':this.headers[i].columnAttr});
                } else if (this.headers[i].columnType == "DEPARTMENT") {
                    this.inputDeptForms.push({name: this.headers[i].columnName,value: "",id: this.headers[i].columnCode,division: this.headers[i].columnDivision, 'attr':this.headers[i].columnAttr});
				} else {
                    if (this.headers[i].columnName != "No") {
                        // if(this.headers[i].columnAttr == 'companyname'){
                        //     this.inputCompanyForms.push({name: this.headers[i].columnName,value: "",id: this.headers[i].columnCode,division: this.headers[i].columnDivision, 'attr':this.headers[i].columnAttr});
                        // }else if(this.headers[i].columnAttr == 'department'){
                        //     this.inputDeptForms.push({name: this.headers[i].columnName,value: "",id: this.headers[i].columnCode,division: this.headers[i].columnDivision, 'attr':this.headers[i].columnAttr});
                        // }else{
                            this.inputSearchForms.push({name: this.headers[i].columnName,value: "",id: this.headers[i].columnCode});
                        // }
                    }
				}
			}
		},
		/*
		* Load data
		*/
		async classifyData() {
            var params = [];
			params = { mid: this.properties.mid };
            params["monthly"] = this.picker;

			if (this.sortField) params["sortName"] = this.sortField;
			if (this.sortOrder) params["sortOrder"] = this.sortOrder;

			// input type
			for (let i in this.inputSearchForms) {
				if (this.inputSearchForms[i].value) params[this.inputSearchForms[i].id] = this.inputSearchForms[i].value;
			}
			// // date type
			for (let i in this.dateSearchForms) {
				if (this.dateSearchForms[i].fvalue || this.dateSearchForms[i].evalue) {
					params[this.dateSearchForms[i].id] = this.dateSearchForms[i].fvalue +","+this.dateSearchForms[i].evalue;
				}
			}

			for (let i in this.dateRangeSearchForms) {
				if (this.dateRangeSearchForms[i].fvalue || this.dateRangeSearchForms[i].evalue) {
					params[this.dateRangeSearchForms[i].id] = this.dateRangeSearchForms[i].fvalue +","+this.dateRangeSearchForms[i].evalue;
				}
            }
            
            for (let i in this.inputCompanyForms) {
				if (this.companyName) params[this.inputCompanyForms[i].id] = this.companyName;
            }
            
            for (let i in this.inputDeptForms) {
				if (this.deptName) params[this.inputDeptForms[i].id] = this.deptName;
			}

			// check box type
			for (let i in this.checkboxSearchForms) {
				let inputKey = this.checkboxSearchForms[i].id;
				let checkValueStr = [];
				for (let j in this.checkboxSearchForms[i].subs) {
					let checkid = this.checkboxSearchForms[i].subs[j].codeCode;
					if ($("#" + checkid).is(":checked")) {
						checkValueStr[i] =
						checkValueStr.length > 0 ? checkValueStr[i].concat(",", $("#" + checkid).val()) : $("#" + checkid).val();
					}
				}
				if (checkValueStr[i]) params[inputKey] = checkValueStr[i];
			}
            var request = { params: params };
			this.loading = true;
			await this.$axios.get(this.$apiHost + "/" + this.$route.name + "/search", request).then(res => {
                if (res.data.searchedMonth != '') {
                    this.picker = res.data.searchedMonth;
                }
				// api.themoviedb.org manage max 100 pages
				this.data = [];
				let exp_result = common.thisDetailResult(this.properties.mid, this.menuData);
				res.data.list.forEach((a,index)=>{
					exp_result.forEach((b, c)=>{
					if(c == 0) a['R'] = 0
					a[b.codeCode] = 0
					});
					let cnt = 0
					if(!common.isNull(a.rscnt)){
						a.rscnt.forEach(b=>{
							a[b.f1] = b.f2;
							cnt = Number(cnt) + Number(b.f2);
						})
					}
					a.wait = Number(a.totalcnt) - Number(cnt);
					// if (!common.isNull(a.count)) { //plating 메뉴 토탈값 가공 추가
					// 	for (let i in this.headers) {
					// 		if (this.headers[i].columnName === 'Total') {
					// 			a[this.headers[i].columnCode] = a.count; 
					// 		}
					// 	}
                    // }
                    for (let i in this.headers) {
                        if (this.headers[i].columnName === 'Total') {
                            a[this.headers[i].columnCode] = !common.isNull(a.totalcnt) ? a.totalcnt : 0 
                        }
                    }
					a.no = res.data.list.length - index;
					this.data.push(a);
				})
				let currentTotal = res.data.list.length;
				if (res.data.list.length / this.perPage > 100) {
					currentTotal = this.perPage * 100;
				}
				this.total = currentTotal;
				this.loading = false;
				})
				.catch(error => {
				this.data = [];
				this.total = 0;
				this.loading = false;
				throw error;
			});

			if(!this.b_clone){
				const lt = $(".table-wrapper").clone().appendTo(".fixedHeader");
				$(".fixedHeader .table-wrapper .table tbody").toggle()
				for(let i = 0; i < $("#listTable").find("th").length; i++){
					$(".fixedHeader .table-wrapper .table thead").find("th:eq("+i+")").width($("#listTable").find("th:eq("+i+")").width());
				}
				this.b_clone = true;
			}
		},
		/*
		* Handle page-change event
		*/
		onPageChange(page) {
			this.page = page;
			this.classifyData();
		},
		/*
		* Handle sort event
		*/
		onSort(field, order) {
			this.sortField = field;
			this.sortOrder = order;
			this.classifyData();
		},
        authCheck(cid) {
            var auth_bol = false;
            //token decode
            const token = this.$store.getters.getAccessToken;
            var base64Url = token.split(".")[1];
            var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
            var jsonPayload = decodeURIComponent(
                atob(base64)
                .split("")
                .map(function(c) {
                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
            );
            let userData = JSON.parse(jsonPayload);

            let share = [
                '4e18c5c8-db0a-4877-86bb-f41b6b4915c6',
                '0fde72f7-d5ed-4519-9c8d-5c24676e668c',
                '696dfc87-1947-440f-83c7-8260ecc6008b',
                'e978caae-fb8a-4c4c-a519-1dbd7200334c'
            ];

            if (cid == this.clientManager) {
                console.log(1)
                auth_bol = true;
            } else if (cid == userData.id) {
                console.log(2)
                auth_bol = true;
            } else if (share.includes(userData.id) && share.includes(cid)) {
                console.log(3)
                auth_bol = true;
            }
            // await this.$axios.get(this.$apiHost + '/auth', {params:{'creatorId':cid}})
            // .then(res => {
            //    auth_bol = res.data.results;
            // }).catch(err => {
            //    console.log(err);
            // });
            return auth_bol;
        },
        /* drafts상태의 실험 번호 접근 시 */
        async approvalCheck(uid) {
            try {
                const userId = this.userid;
                let params = [];
                params = {
                    'uId' : uid,
                    'userId' : userId
                }
                let request = {params : params}
                await this.$axios.get(this.$apiHost + "/approvals/approver", request)
                .then(res=>{
                    if (res.data) {
                        this.$router.push({
                            name: this.$route.name + "_detail",
                            params: { mid: this.properties.mid, uid: uid, type: "detail" }
                        });
                        
                    } else {
                        this.$router.push({
                            name: this.$route.name + "_completion",
                            params: { mid: this.properties.mid, uid: uid, type: "detail" }
                        });
                    }
                    return false;
                });
            } catch (error) {   
                console.log(error)
            }
        },
		/*
		* Handle page move
		*/
        goPage(uid, state, cid) {
            const superManager = [
                'bec59445-8990-42ee-a5fb-2ca6def955e5',
                'f809cb3e-2adb-4d08-bbec-3912dce077d2',
                'a5c2c35d-cb91-453a-8156-f74a3dfc1338',
                'ab5e68b8-2634-47b2-b8e9-ed43ff6979ce'
            ];
            
            if (this.$route.name === 'orderconfirms') {
                if (Number(state) < 90000) {
                    this.$router.push({name: this.$route.name + "_detail",params: { mid: this.properties.mid, uid: uid ,type: "detail" }
                });
                } else {
                    this.$router.push({name: this.$route.name + "_completion",params: { mid: this.properties.mid, uid: uid, type: "detail" }
                });
                }
            } else if (this.$route.name === 'results') {
                this.$router.push({name: this.$route.name + "_detail",params: { mid: this.properties.mid, uid: uid, type: "detail", task: this.properties.task}});
            } else if (Number(state) < 90000) {
                if (this.authCheck(cid)) {
                    this.$router.push({name: this.$route.name + "_detail",params: { mid: this.properties.mid, uid: uid, type: "detail" }
                    });
                } else {
                    if (this.$route.name == 'platinges') {
                        if (superManager.includes(this.userid)) {
                            this.$router.push({name: this.$route.name + "_detail",params: { mid: this.properties.mid, uid: uid, type: "detail" }});
                        } else {
                            this.$router.push({name: this.$route.name + "_completion",params: { mid: this.properties.mid, uid: uid, type: "detail" }});
                        }
                    } else {
                        this.$router.push({name: this.$route.name + "_completion",params: { mid: this.properties.mid, uid: uid, type: "detail" }});
                    }
                }
            } else if (Number(state) == 90000) { //drafts
                if (this.official == 'CC070') {
                    this.$router.push({name: this.$route.name + "_completion",params: { mid: this.properties.mid, uid: uid, type: "detail" }});
                } else {
                    this.approvalCheck(uid);
                }
            } else if (this.mainName === "Management") {
                this.$router.push({name: this.$route.name + "_detail",params: { mid: this.properties.mid, uid: uid, type: "detail" }});
            } else {
				if(this.subName.toLowerCase() === 'pipeline'){
					this.$router.push({name: this.$route.name + "_detail",params: { mid: this.properties.mid, uid: uid, type: "detail" }});
				}else if(this.$route.name === 'pipelinetask'){
                    this.$router.push({name: this.$route.name + "_detail",params: { mid: this.properties.mid, uid: uid, type: "detail" }});
                }else if(this.$route.name === 'equipments'){
                    this.$router.push({name: this.$route.name + "_detail",params: { mid: this.properties.mid, uid: uid, type: "detail" }});
                }else{
					this.$router.push({name: this.$route.name + "_completion",params: { mid: this.properties.mid, uid: uid, type: "detail" }});
				}

            }
        },

        /*
        * Handsontable Reception no click is chat.vue send uuid
        */
        sendId(id){
            bus.$emit("receptid", id);
            return false;
		},
        /*
        * Qwarp
        */
    	async loadHtml(id){
			try {
				let params = [];
				params = {
					'id' : id
				};
				let request = {params : params};
				const html = await this.$axios.get(this.$apiHost + "/results/qwrap", request);
				
				let path = this.$apiHost + html.data;
				window.open(path);
                
                return false;
			} catch (error) {
				console.log(error);
			}
		},
        /*
        * Research 
        */
    	async dialogHandler(id){
			try {
                this.resultId = id;
                this.researchReportDialog = true;
                return false;
			} catch (error) {
				console.log(error);
			}
		},
        /*
        * Research 
        */
    	async setLinkdialogHandler(row){
			try {
                // this.resultId = id;
                if (row.sampleInfo) {
                    this.company = row.sampleInfo.company ? row.sampleInfo.company : this.company
                    this.receptionDate = row.sampleInfo.receptionDate ? row.sampleInfo.receptionDate : this.receptionDate
                    this.targetRegion = row.sampleInfo.targetRegion ? row.sampleInfo.targetRegion : this.targetRegion
                    this.rType = row.sampleInfo.reportType ? row.sampleInfo.reportType : this.rType
                    this.requestedRead = row.sampleInfo.requestedRead ? row.sampleInfo.requestedRead : this.requestedRead
                    this.rarefiedRead = row.sampleInfo.rarefiedRead ? row.sampleInfo.rarefiedRead : this.rarefiedRead
                    this.sequencer = row.sampleInfo.sequencer ? row.sampleInfo.sequencer : this.sequencer
                    this.driveLink = row.sampleInfo.driveLink ? row.sampleInfo.driveLink : this.driveLink
                }
                console.log(1)
                this.selectedRow = row;
                this.linkDialog = true;
                return false;
			} catch (error) {
				console.log(error);
			}
		},
    	async setLink(){
         	let sampleInfo = {
                company: this.company,
                receptionDate: this.receptionDate,
                targetRegion: this.targetRegion,
                reportType: this.rType,
                requestedRead: this.requestedRead,
                rarefiedRead: this.rarefiedRead,
                sequencer: this.sequencer, 
                driveLink: this.driveLink,
            }
            // if (this.driveLink) {
                try {
                    let params = { row: this.selectedRow,  sampleInfo};
                    let path = "/results/update";
                    const res = await this.$axios.patch(`${this.$apiHost}${path}`, params);
                    
                    this.classifyData();
                    // this.resultId = id;
                    this.linkDialog = false;
                    this.snackBar = true;
                    this.snackBarMessage = `Completed saving changes`;
                    return false;
                } catch (error) {
                    console.log(error);
                    return false;
                }

            // } else {
            //     this.snackBar = true;
            //     this.snackBarMessage = `Please enter a Drive Link`;
            //     return false;
            // }
		},
        /*
        * Research 
        */
    	async dialog3Handler(props){
			try {
                this.dialog3 = true;
                this.readList = [];
                this.readTask = ''; 

                if (props.readList) {
                    this.readTask = props.taskSerial;

                    for (let i of props.readList) {
                        let keyValue = i.split(':');
                        let key = keyValue[0];
                        let value = keyValue[1].trim();
                        this.readList.push({key, value})
                    } 
                }
                return false;
			} catch (error) {
				console.log(error);
			}
		},
    	async loadReport(){
			try {
                this.researchReportDialog = false;
                // this.isLoading = true;
                this.btnLoading = true;
                this.overlay = true;

                if (this.reportType === 'Qiime2 Microbiome Report') {
                    this.downloadMsg = '리포트를 생성 중입니다.';
                    let params = {
                        "id": this.resultId,
                        "type": this.reportType,
                    }
                    await this.$axios.patch(`${this.$apiHost}/results/research`, params,
                    {
                        responseType: "arraybuffer", 
                        onDownloadProgress: progressEvent => {
                            this.downloadMsg = '다운로드를 시작합니다.';
                            const percentage = Math.round(
                                (progressEvent.loaded * 100) / progressEvent.total
                            );
                            this.downloadProgress = percentage;
                        }
                    }).then(res => {
                        const link = document.createElement('a')
                        let blob = new Blob([res.data], {
                            type: res.headers["content-type"],
                        });
                        const contentDisposition = res.headers['content-disposition']; // 파일 이름
                        let fileName = 'unknown';
                        if (contentDisposition) {
                            const [ fileNameMatch ] = contentDisposition.split(';').filter(str => str.includes('filename'));
                            if (fileNameMatch)
                            [ , fileName ] = fileNameMatch.replace(/"/g, '').split('=');
                        }
                        // let seperatePath = path.split('/');
                        // let fileName = seperatePath[seperatePath.length - 1];
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        this.overlay = false;
                        this.downloadProgress = '';
                        this.isLoading = false;
                        this.btnLoading = false;
                        this.reportType = '';
                        return false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.isLoading = false;
                        this.btnLoading = false;
                        this.reportType = '';
                        return false;
                    });
                } else {
                    let params = [];
                    params = {
                        "id": this.resultId,
                        "type": this.reportType,
                    };
                    console.log(this.reportType);
                    let request = {params : params};
                    let response = await this.$axios.get(this.$apiHost + "/results/research", request);
                    console.log(response)
                    this.isLoading = false;
                    this.btnLoading = false;
                    window.open(response.data);
                    this.reportType = '';
                    return false;
                }

			} catch (error) {
                this.reportType = '';
                this.researchReportDialog = false;
                this.isLoading = false;
                this.btnLoading = false;
				console.log(error);
			}
		},
		onScroll(e) {
			// console.log(window.top.scrollY); /* or: e.target.documentElement.scrollTop */
			if(window.top.scrollY > 200){
				//display-inline-blockwk
				this.b_scroll = true;
			}else{
				this.b_scroll = false;
			}
		}
    },
	components: {
		datePicker,
		moment,
        vueCustomScrollbar,
        Chat
	},
	computed: {
        filteredCompArray() {
            return this.autoCompanyData.filter(option => {
                return (
                option
                    .toString()
                    .toLowerCase()
                    .indexOf(this.companyName.toLowerCase()) >= 0
                );
            });
        },
        filteredDeptArray() {
            return this.autoDeptData.filter(option => {
                return (
                option
                    .toString()
                    .toLowerCase()
                    .indexOf(this.deptName.toLowerCase()) >= 0
                );
            });

        }
    },
	watch: {
		$route: function(to, from) {
            if (this.$route.name === "experiments") this.$router.go();
            if (this.$route.name === "results") {
                // this.properties.type = to.params.type;
                // this.properties.mid = to.params.mid;
                // this.properties.task = to.params.task;
                sessionStorage.removeItem('type');
                sessionStorage.removeItem('mid');
                sessionStorage.removeItem('task');
                sessionStorage.setItem('type', to.params.type);
                sessionStorage.setItem('mid',to.params.mid);
                sessionStorage.setItem('task',to.params.task);
                // this.$router.push({name: "results", params: { mid: to.params.mid, type: "list", task: to.params.task}});

                this.$router.go()
            };
		},
	},
   
	};
</script>

<style scoped>
@import "../../assets/css/buefy.css";
</style>
<style>
div > .v-application--wrap {
    min-height: 100%;
    max-width: initial;
}

.v-picker__title {
    padding: 7px;
}

.v-date-picker-header {
    padding: 0px 16px;
}

.v-date-picker-table--month td {
    height: 32px;
}

.v-date-picker-table {
    height: 130px;
}
.v-application .primary {
    background-color: #7987a1 !important;
}

.v-date-picker-title__date {
    font-size: 20px;
}

.v-btn:not(.v-btn--round).v-size--default {
    height: 30px;
    min-width: 58px;
}


</style>


// WEBPACK FOOTER //
// src/views/Common/List.vue